import React from "react";
import { cn } from "../../../common/u1/cn";
import { iconForUpdate } from "../../../common/u1/updateIcon";
import { relativeTime } from "../../../common/u1/relativeTime";

/* A tracked buyer's recent changes, listed under its row. */

/* Re-exported: this panel used to own the helper, and two screens now age a
   timestamp the same way, so it lives in common/u1. Kept exported here so
   this file's own callers and tests are unaffected. */
export { relativeTime };

export const TrackedUpdateRow = ({ update }) => {
  const Icon = iconForUpdate(update?.content);
  const when = relativeTime(update?.timestamp);

  return (
    <li
      className={cn(
        "flex items-center gap-3 border-b border-[var(--line)] px-3.5 py-3",
        "last:border-b-0 sm:px-4"
      )}
    >
      {/* A muted tile, not the coral one the Following strip uses: inside a
          card of its own the mark is a bullet, and five coral tiles down a
          list would shout over the row above. */}
      <span
        aria-hidden="true"
        className={cn(
          "flex h-8 w-8 shrink-0 items-center justify-center rounded-lg",
          "bg-[var(--slate-2)] text-[var(--muted)]"
        )}
      >
        <Icon size={15} />
      </span>

      <span className="min-w-0 grow basis-0">
        <span className="block text-[13.5px] font-semibold text-[var(--ink)] font-sans">
          {update?.content}
        </span>
      </span>

      {when && (
        <span className="shrink-0 pl-3 text-[12px] text-[var(--muted)] font-sans">{when}</span>
      )}
    </li>
  );
};

export const TrackedUpdatesPanel = ({ id, updates = [], className = "" }) => {
  if (updates.length === 0) {
    return (
      <p
        id={id}
        className={cn(
          "m-0 px-3.5 py-4 text-[13.5px] text-[var(--muted)] font-sans sm:px-4",
          className
        )}
      >
        No changes recorded yet.
      </p>
    );
  }

  return (
    <ul id={id} className={cn("m-0 list-none p-0", className)}>
      {updates.map((update, i) => (
        <TrackedUpdateRow
          /* CompanyUpdate rows carry update_id; the content/timestamp pair is
             the fallback, and the index guards a payload with neither. */
          key={update?.update_id || `${update?.content}-${update?.timestamp}` || i}
          update={update}
        />
      ))}
    </ul>
  );
};

export default TrackedUpdatesPanel;
